module.exports = __webpack_public_path__ + "static/image_HSA-f8be623139de299d0a28c338d3f88dc1.jpg";